export default "__VITE_ASSET__DU32i5in__"